export const SETUP_USERS_EDIT_USER = 'SETUP_USERS_EDIT_USER';
export const SETUP_USERS_SAVE_USER = 'SETUP_USERS_SAVE_USER';
export const SETUP_USERS_PAGENATIONS = 'SETUP_USERS_PAGENATIONS';
export const SETUP_USERS_INCREMENT_TOTAL = 'SETUP_USERS_INCREMENT_TOTAL';
export const SETUP_USERS_LAST_PAGE = 'SETUP_USERS_LAST_PAGE';
export const SETUP_USERS_SEARCHKEY = 'SETUP_USERS_SEARCHKEY';
export const SETUP_USERS_USERS = 'SETUP_USERS_USERS';

export const SETUP_USERS_TOGGLE_DEPARTMENT_SELECT_DIALOG = 'SETUP_USERS_TOGGLE_DEPARTMENT_SELECT_DIALOG';
export const SETUP_USERS_DEPARTMENT = 'SETUP_USERS_DEPARTMENT';
export const SETUP_USERS_SCOPE_VALUE = 'SETUP_USERS_SCOPE_VALUE';



// WEBPACK FOOTER //
// ./src/views/Setup/Users/flow/actionType.js